// extracted by mini-css-extract-plugin
module.exports = {"controls":"P_bB","margin":"P_bC","control":"P_0","link":"P_bD","index":"P_6","dividerAnimation":"P_p"};